export default __webpack_public_path__ + "static/pic01-6c9f5065cf19d7d3cfc6b312d044cea1.jpg";